<template>
   <div class="layout">
        <div class="layout__header">
            <h3>Vendedores</h3>
        </div>
        <k-table :filterStatus="filterStatus" @crear="crear" :createButton="createButton" 
        :editButton="false" :deleteButton="false" ref="listaVendedores" 
        @seleccionar="seleccionar" :path="url + '/vendedores/search'" :columns="[
            {
                display : 'Código',
                value : 'codigo'
            },
            {
                display : 'Nombre',
                value : 'nombre'
            },
            {
                display : 'Descripción',
                value : 'descripcion'
            },
            {
                display : 'Fecha de creación',
                value : 'created_at'
            },
            {
                display : 'Fecha de modificación',
                value : 'updated_at'
            }
        ]">
        </k-table>
        <modal :width="'80%'" height="auto" :scrollable="true"  name="vendedor">
            <vendedor :searchButton="searchButton" @created="createdVendedor"></vendedor>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        createButton : {
            type : Boolean,
            required : false,
            default : true
        },
        filterStatus : {
            type : Boolean,
            required : false,
            default : true
        },
        searchButton : {
            type : Boolean,
            required : false,
            default : false
        }
    },
    data : function () {
        return {
            currentIndex : -1,
            url : url
        }
    },
    methods : {            
        seleccionar : function(currentCategoria) {
            this.$emit('selected', currentCategoria);
        },
            crear : function () {
            this.$modal.show('vendedor');
        },
        createdVendedor: function (vendedor) {
            this.$refs.listaVendedores.actualizarLista(vendedor);
            this.$modal.hide('vendedor');
        }
    }

}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/vendedores/ListaVendedores.vue